// extracted by mini-css-extract-plugin
export default {"container":"o0YiMAP8","wrapper":"B1_vmNNd","applicationName":"F4gGoZNE","buttons":"oUKLixL4","windowsButtons":"hKXvGlWy","windowsButton":"Pgysk0gP"};